import type { CapabilityEnum } from "@faire/web-api/faire/session/CapabilityEnum";
import * as React from "react";

import { useUserStore } from "@faire/retailer/stores/domain/UserStore";

interface IProps {
  capability: keyof typeof CapabilityEnum;
  errorComponent: React.ReactElement | null;
  children: React.ReactNode;
}

/**
 * Wrapper component that only renders the children if the user has the sufficient capability.
 *
 * @param capability the capability that is required to view the protected child component.
 * @param errorComponent the fallback component that will be rendered if the user does not have the sufficient capability.
 * @param children the protected child components we want to wrap.
 */
export const CapabilitySpecificComponent: React.FC<IProps> = ({
  capability,
  errorComponent,
  children,
}) => {
  const { userHasSufficientCapability } = useUserStore([
    "userHasSufficientCapability",
  ]);
  const canView = userHasSufficientCapability(capability);

  if (!canView) {
    return errorComponent;
  }

  return <>{children}</>;
};
